export enum FieldName {
  type = "type",
  receiver = "receiver",
  receivers = "receivers",
  sender = "sender",
  senderName = "senderName",
  content = "content",
  comment = "comment",
  date = "date",
  document = "document",
  sent = "sent",
  response = "response",
  responseDate = "responseDate",
  responder = "responder",
}

export interface Input {
  [FieldName.response]: string;
}
